<template>
    <b-form>
        <b-form-group :label="$gettext('Name')" label-for="name">
            <b-form-input id="name" v-model="value.name" required></b-form-input>
        </b-form-group>

        <div @click="moreDetails()" class="more-details-button">
            <div>{{ $gettext('More') }}</div>
            <font-awesome-icon v-if="!moreAccordion" aria-hidden="true" icon="fa-solid fa-caret-right" />
            <font-awesome-icon v-if="moreAccordion" aria-hidden="true" icon="fa-solid fa-caret-down" />
        </div>

        <b-collapse v-model="moreAccordion">
            <b-card-body>
                <b-row>
                    <b-col>
                        <b-form-group :label="$gettext('Country')" label-for="country">
                            <b-form-select :options="countries" v-model="value.country" :placeholder="$gettext('Netherlands')"></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group :label="$gettext('Tax ID')" label-for="tax_id">
                            <b-form-input id="tax_id" v-model="value.tax_id"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group :label="$gettext('City')" label-for="city">
                            <b-form-input id="city" v-model="value.city"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group :label="$gettext('Postal code')" label-for="postal_code">
                            <b-form-input id="postal_code" v-model="value.postal_code"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group :label="$gettext('Address')" label-for="address">
                            <b-form-input id="address" v-model="value.address"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-collapse>
    </b-form>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'NewSupplierForm',
    props: {
        value: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            moreAccordion: false
        }
    },
    computed: {
        ...mapGetters({
            countries: 'main/getCountryOptions'
        })
    },
    methods: {
        moreDetails() {
            this.moreAccordion = !this.moreAccordion
        },
        assignTaxIdFields() {
            const taxId = (this.value.tax_id || '').trim()
            const hasCountryCodePrefix = /^[A-Za-z]{2}/.test(taxId)

            this.value.btw = hasCountryCodePrefix ? taxId : ''
            this.value.kvk = hasCountryCodePrefix ? '' : taxId
        }
    }
    
}
</script>

<style lang="scss">
    .mastermodal-view--right{
        z-index: auto !important;
    }
</style>

<style lang="scss" scoped>
    .more-details-button {
        cursor: pointer;
        display: flex;
        gap: 5px;
        align-items: center;
        color: $colorBlue;
    }

    .subtitle-text {
        font-size: 16px;
        color: $colorTextLight;
    }
</style>